<template>
  <div class="myhome-schools xs-12 m-8 l-9">
    <h2 v-if="user.teacher" class="dea-heading--medium-xxl myhome-schools__main-title" tabindex="0">Il mio lavoro</h2>
    <h2 v-else-if="user.principal" class="dea-heading--medium-xxl myhome-schools__main-title" tabindex="0">
      Le mie scuole
    </h2>

    <div v-if="user.teacher" class="myhome-schools__personal-info">
      <div class="myhome-schools__personal-info-title">
        <div class="dea-heading--medium-m">Sono:</div>
        <Links
          v-if="mainSchoolRoleEmpty()"
          class="dea-links--large dea-links--pointer"
          :class="`dea-links--${user.targetCss.colorMod}`"
          @click="changeSchoolRoleVisible = true"
        >
          Modifica
        </Links>
      </div>
      <div class="myhome-schools__personal-info-role">
        <div
          v-if="!mainSchoolRoleEmpty()"
          class="myhome-schools__personal-info-role-description dea-heading--regular-s"
        >
          {{ user.main_school_roles[0] }}
        </div>
        <div v-if="!mainSchoolRoleEmpty()" class="myhome-schools__personal-info-role-note dea-heading--regular-xs">
          Se hai bisogno di una modifica contatta la tua agenzia di zona
        </div>
        <div v-else class="myhome-schools__personal-info-list-item dea-heading--light-s">
          Non hai ancora scelto il tuo ruolo. Aggiungilo selezionando "Modifica"
        </div>
      </div>
    </div>

    <div v-if="user.teacher" class="myhome-schools__activities">
      <div class="myhome-schools__activities-title">
        <div class="dea-heading--medium-m">Le mie altre attività</div>
        <Links
          class="dea-links--large dea-links--pointer"
          :class="`dea-links--${user.targetCss.colorMod}`"
          @click="changeActivityVisible = true"
        >
          Modifica
        </Links>
      </div>
      <div v-if="user.school_roles && user.school_roles !== ' '" class="myhome-schools__activities-list">
        <div
          v-for="(role, index) in user.school_roles.split(',')"
          :key="index"
          class="myhome-schools__activities-list-item dea-heading--light-s"
        >
          {{ role }}
        </div>
      </div>
      <div v-else class="myhome-schools__activities-list-item dea-heading--light-s">
        Non hai inserito altre attività. Aggiungi altre attività al tuo profilo selezionando "Modifica"
      </div>
    </div>

    <div v-if="user.teacher" class="myhome-schools__grade-subjects">
      <MyProfileModify
        empty-label="Per favore, completa il tuo profilo"
        :link-color="user.targetCss.colorMod"
        :options="gradeAndSubjects"
        title="Grado scolastico e materie d'insegnamento"
        @open-modify="addSubjectsVisible = true"
      />
    </div>
    <div class="myhome-schools__header">
      <div class="myhome-schools__header-title">
        <div v-if="user.teacher" class="dea-heading--medium-xl">Le mie scuole</div>
        <div class="dea-heading--light-l myhome-schools__school-year">Anno scolastico {{ schoolYear() }}</div>
      </div>
      <Buttons class="myhome-schools__header-button dea-button dea-button--large" icon="add" @click="addSchool">
        Aggiungi scuola
      </Buttons>
    </div>
    <div class="myhome-schools__content">
      <SchoolSelected
        v-for="(school, idx) in user.schools"
        :key="idx"
        :name="school.name"
        :label="school.grade.name"
        :address="createAddress(school)"
        :leading-school="school.polo"
        @delete-school="deleteSchool(school)"
        @modify-school="modifySchool(school)"
      />
    </div>
    <MainSchoolRoleModal
      v-if="changeSchoolRoleVisible"
      :user="user"
      :visible="changeSchoolRoleVisible"
      @close-modal="changeSchoolRoleVisible = false"
    />
    <ChangeActivitiesModal
      v-if="changeActivityVisible"
      :user="user"
      :visible="changeActivityVisible"
      @close-modal="changeActivityVisible = false"
    />
    <AddSchoolModal
      v-if="addSchoolVisible"
      :school-grade="schoolGrade"
      :school-to-modify="schoolToModify"
      :user="user"
      :visible="addSchoolVisible"
      @close-modal="addSchoolVisible = false"
    />
    <AddSubjectsModal
      v-if="addSubjectsVisible"
      :cluster-teacher="getClusters"
      :user="user"
      :visible="addSubjectsVisible"
      @close-modal="closeAddSubject()"
    />
    <DeleteSchoolModal
      v-if="schoolToDelete"
      :school-to-delete="schoolToDelete"
      :user="user"
      :visible="deleteSchoolVisible"
      @close-modal="deleteSchoolVisible = false"
    />
  </div>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import Links from "@/components/elements/Links";
import SchoolSelected from "@/components/patterns/SchoolSelected";
import AddSchoolModal from "../components/AddSchoolModal";
import AddSubjectsModal from "../components/AddSubjectsModal";
import ChangeActivitiesModal from "~/components/myProfile/components/ChangeActivitiesModal";
import DeleteSchoolModal from "../components/DeleteSchoolModal";
import MainSchoolRoleModal from "~/components/myProfile/components/MainSchoolRoleModal";
import MyProfileModify from "../components/MyProfileModify";
import Schools from "../../../clients/schools";
import setFocus from "~/helpers/setFocus";

export default {
  name: "MyProfileSchools",
  components: {
    AddSchoolModal,
    AddSubjectsModal,
    Buttons,
    ChangeActivitiesModal,
    DeleteSchoolModal,
    Links,
    MainSchoolRoleModal,
    MyProfileModify,
    SchoolSelected,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      addSchoolVisible: false,
      addSubjectsVisible: false,
      changeActivityVisible: false,
      changeSchoolRoleVisible: false,
      clusterTeacher: [],
      deleteSchoolVisible: false,
      noRoleString: "Nessuna delle precedenti",
      schoolToDelete: null,
      schoolToModify: null,
    };
  },
  computed: {
    getClusters() {
      return this.clusterTeacher.map(el => el.cluster);
    },
    gradeAndSubjects() {
      const response = [];
      if (this.clusterTeacher.length) {
        const subjectsList = this.clusterTeacher.map(el => {
          return { degree_id: el.cluster.degree_id, name: el.cluster.name };
        });
        const gradeLabel = { compact: "" };
        const subjectsLabel = { compact: "" };
        subjectsList.forEach((el, idx) => {
          if (!idx) {
            gradeLabel.compact = this.$root.asyncConf.degrees_json
              .filter(grade => el.degree_id === grade.id)
              .map(grade => grade.name)
              .reduce((acc, curr) => acc + curr, "");
            subjectsLabel.compact = el.name;
          } else {
            subjectsLabel.compact = `${subjectsLabel.compact}, ${el.name}`;
          }
        });
        response.push(gradeLabel);
        response.push(subjectsLabel);
      }
      return response;
    },
    schoolGrade() {
      if (this.getClusters.length) {
        return this.$root.asyncConf.degrees_json[this.getClusters[0].degree_id - 1].id;
      }
      return null;
    },
  },
  async mounted() {
    setFocus("myhome-schools__main-title");

    this.getClusterTeacher();
  },
  activated() {
    setFocus("myhome-schools__main-title");
  },
  methods: {
    addSchool() {
      this.schoolToModify = null;
      this.addSchoolVisible = true;
    },
    closeAddSubject() {
      this.getClusterTeacher();
      this.addSubjectsVisible = false;
    },
    createAddress(school) {
      return `${school.address} - ${school.zip_code} ${school.city} (${school.area_id})`;
    },
    deleteSchool(school) {
      this.schoolToDelete = school;
      this.deleteSchoolVisible = true;
    },
    async getClusterTeacher() {
      this.clusterTeacher = await Schools.getClusterTeacher(this.$root.config, this.user.id);
    },
    mainSchoolRoleEmpty() {
      if (
        !this.user.main_school_roles ||
        (this.user.main_school_roles.length === 1 && this.user.main_school_roles[0] === this.noRoleString)
      )
        return true;
      return false;
    },
    modifySchool(school) {
      this.schoolToModify = school;
      this.addSchoolVisible = true;
    },
    schoolYear() {
      const year = new Date().getFullYear();
      return `${year}-${year + 1}`;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

$container-margin: 180px;

$dea-modal-min-width: 600px;

.myhome-schools {
  &__main-title {
    margin-top: 0;
  }

  &__activities {
    margin-bottom: $space-x-large;
  }

  &__activities-title {
    display: flex;
    justify-content: space-between;
  }

  &__activities-list-item {
    margin-top: $space-small;
  }

  &__title {
    margin-bottom: $space-base;
  }

  &__activities,
  &__grade-subjects,
  &__personal-info {
    @include media(">s") {
      margin-right: $container-margin;
    }
  }

  &__personal-info {
    margin-bottom: $space-large;

    &-title {
      display: flex;
      justify-content: space-between;
    }

    &-role {
      @include media("<=m") {
        flex-direction: column;

        &-description {
          margin-bottom: $space-small;
        }
      }

      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin: $space-base 0;
    }
  }

  &__header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    &-title {
      display: flex;
      flex-direction: column;
    }
  }

  &__school-year {
    margin-top: $space-x-small;
  }

  &__content {
    margin-top: $space-large;

    .dea-school-selected {
      margin: $space-small 0;
    }
  }

  .dea-modal {
    @include media("<=l") {
      min-width: unset;
      width: 90%;
    }

    max-height: 90vh;
    min-width: $dea-modal-min-width;
    overflow-y: auto;
  }
}
</style>
